import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'shared/components';
import { AITextareaField } from './AITextareaField';
import { ProposalAIPrimaryButton } from './ProposalAIPrimaryButton';

const PROMPT_MAX_LENGTH = 500;

interface Props {
  prompt: string;
  hasBrief: boolean;
  hasGenerated: boolean;
  canExpandBrief: boolean;
  isExpandingBrief: boolean;
  onPromptChange: (value: string) => void;
  onExpandBrief: React.MouseEventHandler<HTMLButtonElement>;
  onReset: React.MouseEventHandler<HTMLButtonElement>;
}

export const ProposalAIGeneratorPromptSection: React.FC<Props> = ({
  prompt,
  hasBrief,
  hasGenerated,
  canExpandBrief,
  isExpandingBrief,
  onPromptChange,
  onExpandBrief,
  onReset,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="proposal-ai-generator__section">
      <AITextareaField
        id="proposal-ai-prompt"
        label={formatMessage({ id: 'proposal-ai.prompt.label' })}
        placeholder={formatMessage({
          id: 'proposal-ai.prompt.placeholder',
        })}
        helpText={formatMessage(
          { id: 'proposal-ai.prompt.helptext' },
          { max: PROMPT_MAX_LENGTH },
        )}
        maxLength={PROMPT_MAX_LENGTH}
        value={prompt}
        onChange={onPromptChange}
        dataCy="proposal-ai-prompt"
      />

      <div className="proposal-ai-generator__action-row">
        <ProposalAIPrimaryButton
          label={
            isExpandingBrief
              ? formatMessage({ id: 'proposal-ai.expand.loading' })
              : hasBrief
                ? formatMessage({ id: 'proposal-ai.expand.refresh' })
                : formatMessage({ id: 'proposal-ai.expand.action' })
          }
          onClick={onExpandBrief}
          disabled={!canExpandBrief}
          btnSelector="proposal-ai-expand-brief"
        />

        {(hasBrief || hasGenerated) && (
          <Button
            style="ghost"
            size="lrg"
            onClick={onReset}
            btnSelector="proposal-ai-reset"
          >
            {formatMessage({ id: 'proposal-ai.reset' })}
          </Button>
        )}
      </div>
    </div>
  );
};
